/* eslint-disable no-param-reassign */
export default {
  beforeMount(el, binding) {
    el.clickOutsideEvent = event => {
      if (!(el === event.target || el.contains(event.target))) {
        if (typeof binding.value === 'function') {
          binding.value(event);
        } else if (binding.value.handler) {
          const shouldClose = typeof binding.value.closeConditional === 'function'
            ? binding.value.closeConditional()
            : true;

          shouldClose && binding.value.handler(event);
        }
      }
    };
    document.addEventListener('click', el.clickOutsideEvent);
  },
  unmounted(el) {
    document.removeEventListener('click', el.clickOutsideEvent);
    delete el.clickOutsideEvent;
  },
};
